import { render, staticRenderFns } from "./StockUp.vue?vue&type=template&id=15e53ccf&scoped=true"
import script from "./StockUp.vue?vue&type=script&lang=js"
export * from "./StockUp.vue?vue&type=script&lang=js"
import style0 from "./StockUp.vue?vue&type=style&index=0&id=15e53ccf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e53ccf",
  null
  
)

export default component.exports